<template>
    <el-dialog
            :title="dataForm.id?'编辑':'新增'"
            :visible.sync="visible"
            :append-to-body="true"
            width="600px">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="80px">
            <el-form-item label="客户姓名" prop="cusName">
                <el-input type="text" v-model="dataForm.cusName" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="cusPhone">
                <el-input type="text" v-model="dataForm.cusPhone" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="小区" prop="cusArea">
                <el-input type="text" v-model="dataForm.cusArea" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="户型" prop="houseType">
                <el-input type="text" v-model="dataForm.houseType" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="风格" prop="style">
                <el-input type="text" v-model="dataForm.style" style="width: 80%;" clearable></el-input>
            </el-form-item>
            <el-form-item label="业务员" prop="userId">
                <el-select v-model="dataForm.userId" filterable placeholder="请选择" clearable>
                    <el-option
                            v-for="item in userList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        <span style="float: left">
                                {{ item.label }}
                                <span style="color: #8492a6; font-size: 12px;">（{{item.isWork ? '离职' : '在职'}}）</span>
                            </span>
                    </el-option>
                </el-select>
                <el-input type="text" v-model="dataForm.tugou" placeholder="兔狗或其他业务员" style="width: 80%;"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="设计师" prop="designId">
                <el-select v-model="dataForm.designId" filterable placeholder="请选择" clearable>
                    <el-option
                            v-for="item in designList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        <span style="float: left">
                                {{ item.label }}
                                <span style="color: #8492a6; font-size: 12px;">（{{item.isWork ? '离职' : '在职'}}）</span>
                            </span>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="客户情况" prop="state">
                <el-select v-model="dataForm.state" filterable placeholder="请选择" clearable>
                    <el-option
                            v-for="item in stateList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="签约时间" prop="tempDate">
                <el-date-picker
                        v-model="dataForm.tempDate"
                        type="datetime"
                        placeholder="选择日期时间"
                        align="right"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input type="textarea" :rows="5" v-model="dataForm.remark" style="width: 80%;"
                          clearable></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">保存</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import {InviteDesign} from "../../api/inviteDesign";
    import {UdUser} from "../../api/udUser";
    import {DateFormat} from "../../utils/dateformat";

    export default {
        name: "invite-design-add-or-update",
        data() {
            let validateMobile = (rule, value, callback) => {
                let reg = /^\d{7,11}$/;
                if (!reg.test(value)) {
                    callback(new Error('请输入7-11位的数字！'))
                } else {
                    callback()
                }
            };
            return {
                visible: false,
                userList: [],
                designList: [],
                stateList: [
                    {value: 1, label: '方案'},
                    {value: 2, label: '意向金'},
                    {value: 3, label: '定金'},
                    {value: 4, label: '80%货款'},
                    {value: 5, label: '全款'},
                    {value: 6, label: '退款'}
                ],
                dataForm: {
                    id: 0,
                    cusName: '',
                    style: '',
                    userId: '',
                    designId: '',
                    cusPhone: '',
                    cusArea: '',
                    houseType: '',
                    tempDate: DateFormat.dateFormatTime(new Date()),
                    remark: '',
                    state: 1,
                    tugou: ''
                },
                dataRule: {
                    cusName: [
                        {required: true, message: '客户姓名不能为空', trigger: 'blur'}
                    ],
                    designId: [
                        {required: true, message: '请选择设计师！', trigger: 'blur'}
                    ],
                    cusPhone: [
                        {required: true, message: '手机号码不能为空', trigger: 'blur'},
                        {validator: validateMobile, trigger: 'blur'}
                    ],
                    cusArea: [
                        {required: true, message: '小区不能为空', trigger: 'blur'}
                    ]
                },
                pickerOptions: {
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                }
            }
        },

        watch: {
            //弹出层关闭清空数据
            visible(newValue, oldValue) {
                if (newValue === false) {
                    this.$nextTick(() => {
                        this.$refs['dataForm'].resetFields()
                    });
                }
            }
        },

        methods: {
            getUserList() {
                UdUser.getUserList().then(res => {
                    if (res.code === 0) {
                        let userList = res.userList;
                        this.userList = [];
                        this.designList = [];
                        userList.forEach((item, index) => {
                            if (item.deparment === 7) { // 获取销售部人员
                                this.userList.push(item);
                            }
                            if (item.deparment === 6) { // 获取设计部人员
                                this.designList.push(item);
                            }
                        });
                    }
                })
            },
            init(id) {
                this.visible = true;
                this.dataForm.id = id;
                this.getUserList();
                if (this.dataForm.id) {
                    InviteDesign.getIvDesignInfo(this.dataForm.id).then(res => {
                        if (res.code === 0) {
                            this.dataForm.cusName = res.designInfo.cusName;
                            this.dataForm.userId = res.designInfo.userId === 0 ? '' : res.designInfo.userId;
                            this.dataForm.designId = res.designInfo.designId;
                            this.dataForm.cusPhone = res.designInfo.cusPhone;
                            this.dataForm.cusArea = res.designInfo.cusArea;
                            this.dataForm.houseType = res.designInfo.houseType;
                            this.dataForm.style = res.designInfo.style;
                            this.dataForm.remark = res.designInfo.remark;
                            this.dataForm.state = res.designInfo.state;
                            this.dataForm.tugou = res.designInfo.tugou;
                            this.dataForm.tempDate = res.designInfo.signTime;
                        }
                    })
                }
            },
            /**
             * 提交
             */
            dataFormSubmit() {
                let datas = {
                    'id': this.dataForm.id,
                    'cusName': this.dataForm.cusName,
                    'userId': this.dataForm.userId === '' ? 0 : this.dataForm.userId,
                    'designId': this.dataForm.designId,
                    'cusArea': this.dataForm.cusArea,
                    'cusPhone': this.dataForm.cusPhone,
                    'remark': this.dataForm.remark,
                    'houseType': this.dataForm.houseType,
                    'style': this.dataForm.style,
                    'state': this.dataForm.state,
                    'tugou': this.dataForm.tugou,
                    'tempDate': this.dataForm.tempDate
                };
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        let type = this.dataForm.id ? 'update' : 'save';
                        InviteDesign.addOrUpdateIvDesign(type, datas).then(res => {
                            if (res.code === 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false;
                                        this.$nextTick(() => {
                                            this.$emit('getDataList');
                                        })
                                    }
                                })
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    }
                });
            }
        }

    }
</script>

<style scoped>

</style>
